<template>
  <template-post-detail-page></template-post-detail-page>
</template>

<script lang="ts">

import templatePostDetailPage from '@/app-template/lib/pages/PostDetailPage.vue';

export default {
  name: "PostDetailPage",
  components: { templatePostDetailPage },
};
</script>